const state = {
  coordinates: {},
  markers: [],
  isMapFullscreen: false,
  isMapFilterOpen: true,
};

const getters = {
  getMapCoordinates: (state) => state.coordinates,
  getMapMarkers: (state) => state.markers,
  getMapFilterState: (state) => state.isMapFilterOpen,
};

const actions = {
  /* getProperties ({ commit }) {
    shop.getProducts(products => {
      commit(types.RECEIVE_PRODUCTS, { products })
    })
  } */
  toggleMapFullscreen({commit}) {
    commit('TOGGLE_MAP_FULLSCREEN');
  },
  closeMapExitFullscreen({commit}) {
    commit('CLOSE_MAP_EXIT_FULLSCREEN');
  },
  toggleMapFilter({commit}) {
    commit('TOGGLE_MAP_FILTER');
  },
  showMapFilter({commit}) {
    commit('SHOW_MAP_FILTER');
  },
  hideMapFilter({commit}) {
    commit('HIDE_MAP_FILTER');
  },
};

const mutations = {
  SET_MAP_COORDINATES(state, {latitude, longitude}) {
    state.coordinates = {latitude, longitude};
  },
  SET_MAP_MARKERS(state, data) {
    state.markers = data;
  },
  TOGGLE_MAP_FILTER(state) {
    state.isMapFilterOpen = !state.isMapFilterOpen;
  },
  SHOW_MAP_FILTER(state) {
    state.isMapFilterOpen = true;
  },
  HIDE_MAP_FILTER(state) {
    state.isMapFilterOpen = false;
  },
  TOGGLE_MAP_FULLSCREEN(state) {
    state.isMapFullscreen = !state.isMapFullscreen;

    if (
      (document.fullScreenElement && document.fullScreenElement !== null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)
    ) {
      if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  },
  CLOSE_MAP_EXIT_FULLSCREEN(state) {
    state.isMapFullscreen = false;

    let searchMap = document.querySelector('.search-map');
    Object.assign(searchMap.style, {display: 'none', opacity: '0'});
    if (document.cancelFullScreen) {
      document.cancelFullScreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen();
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/map.js